// extracted by mini-css-extract-plugin
export default {"nbWatchList":"WatchList_nbWatchList__5c2FC","nbWatchListContent":"WatchList_nbWatchListContent__psIsa"};